import React, {ReactNode} from 'react';
import {Platform, View, StyleSheet, ViewStyle, StyleProp} from 'react-native';

interface BTLinearGradientProps {
  children: ReactNode;
  colors?: string[];
  style?: StyleProp<ViewStyle>;
}

const BTLinearGradient: React.FC<BTLinearGradientProps> = ({
  children,
  colors = ['#4c669f', '#3b5998', '#192f6a'],
  style,
}) => {
  if (Platform.OS === 'web') {
    const gradientString = `linear-gradient(to bottom, ${colors.join(', ')})`;

    return (
      <View
        style={[
          {
            flex: 1,
            backgroundImage: gradientString,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          } as any,
          style,
        ]}>
        {children}
      </View>
    );
  } else {
    const mod = require('react-native-linear-gradient');
    const LinearGradient = mod?.default || mod;
    if (!LinearGradient) {
      return <View style={style}>{children}</View>;
    }
    return (
      <LinearGradient colors={colors} style={[styles.gradient, style]}>
        {children}
      </LinearGradient>
    );
  }
};

const styles = StyleSheet.create({
  gradient: {
    flex: 1,
  },
});

export default BTLinearGradient;

